
<div class="app-container">
  <app-side-navbar></app-side-navbar>
  <app-navigation-bar></app-navigation-bar>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  <app-bottom-footer></app-bottom-footer>
</div>
